import { schema } from 'normalizr';
import { eventSchema } from './eventSchema';

export const eventGuestSchema = new schema.Entity('eventGuest');

eventGuestSchema.define({
  eventId: eventSchema,
});
